import { Container, Grid, Paper } from "@mui/material";
import InviteSummary from "../logic/InviteSummary";


export default function InvitationSummaryPage() {
	return (
		<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
			<Grid container spacing={3}>
				{/* Users within the selected organization grid */}
				<Grid item xs={12}>
					<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
						<InviteSummary />
					</Paper>
				</Grid>
				{/* Example of responsive grid layout */}
				{/* <Grid item xs={12} md={4} lg={3}>
					<Paper
						sx={{
							p: 2,
							display: "flex",
							flexDirection: "column",
							height: 240,
						}}
					>
						<Some Component />
					</Paper>
				</Grid> */}
			</Grid>
		</Container>
	);
}
